import { atom } from "jotai";

/**
 * Tracks if the user has just accepted a custom warning dialog
 * (like the 'Start Over' confirmation). This is used by the
 * beforeunload handler to allow the subsequent intentional navigation
 * without triggering the native browser prompt.
 */
export const userAcceptedWarningAtom = atom(false);
userAcceptedWarningAtom.debugLabel = "userAcceptedWarningAtom";
